import { InfoCircleOutlined } from '@ant-design/icons';
import { Tag, Typography } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface ISimulationBannerProps {
  simulateRole: string;
  simulatedUser?: {
    firstName: string;
    lastName: string;
    assignedOffice?: { name: string } | null;
  } | null;
}

export const SimulationBanner: FC<ISimulationBannerProps> = ({
  simulateRole,
  simulatedUser,
}) => {
  const { t } = useTranslation('dashboard.RecruiterDashboard.simulation');
  return (
    <div
      style={{
        background: '#fff7e6',
        border: '1px solid #ffd591',
        borderRadius: 4,
        padding: '8px 16px',
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
    >
      <InfoCircleOutlined style={{ color: '#fa8c16' }} />
      <Typography.Text style={{ color: '#ad6800' }}>
        <strong>{t('active')}</strong> {t('viewingAs')}
        <Tag color="orange">{simulateRole}</Tag>
        {simulatedUser && (
          <>
            {t('asUser')}
            <strong>
              {simulatedUser.firstName} {simulatedUser.lastName}
            </strong>
            {simulatedUser.assignedOffice && (
              <>
                {t('officeLabel', { name: simulatedUser.assignedOffice.name })}
              </>
            )}
          </>
        )}
        {t('configureInSettings')}
      </Typography.Text>
    </div>
  );
};
